<template>
    <div id="Breadcrumbs">
        <mu-flex class="normarl-nav" align-items="center">
            <mu-icon :value="navIcon" color="grey" :size="18" style="margin-right:4px;"></mu-icon>
            <mu-button flat small color="primary" v-if="title.url" :to="title.url">{{title.name}}</mu-button>
            <span v-else class="title1">{{title.name}}</span>
            <mu-flex v-for="(subTitle, idx) in subTitles" :key="idx" align-items="center">
                <mu-icon value="play_arrow" color="grey" :size="18"></mu-icon>
                <el-button size="small" type="text" v-if="subTitle.url" @click="function() {
                  $router.push(
                    subTitle.url
                  )
                }">{{subTitle.name}}</el-button>
                <span v-else class="title2">{{subTitle.name}}</span>
            </mu-flex>
        </mu-flex>
    </div>
</template>
<script>
export default {
    name: "Breadcrumbs",
    data() {
        return {}
    },
    props: {
        title: Object,
        subTitles: {
            type: Array,
            default: function(){
                return []
            }
        },
        navIcon: String
    },
    methods: {
    }
}
</script>
<style scoped>
.normarl-nav {
    width: 100%;
    background:transparent;
}
.title1 {
    color:#4E5A63;
    font-size:12px;
}
.title2 {
    color:#4E5A63;
    font-size:12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumbs.vue